import { apiClient, type BackendModuleDescriptor, type OrganizationView } from "@nabble/sdk";

/** The enabled modules the user holds a permission of. */
export function fetchMyModules(): Promise<BackendModuleDescriptor[]> {
  return apiClient<BackendModuleDescriptor[]>("/api/me/modules");
}

/** Selects the organization to work in (it also becomes where new items go). */
export function selectOrganization(organizationId: string): Promise<void> {
  return apiClient<void>("/api/me/organization", { method: "PUT", body: { organizationId } });
}

/** One organization at a time, or all of mine together. */
export function setOrganizationView(view: OrganizationView): Promise<void> {
  return apiClient<void>("/api/me/organization-view", { method: "PUT", body: { view } });
}
